module.exports = __webpack_public_path__ + "static/media/1.191a3158.svg";